
import React from "react";
import { useCommonStore } from "@/store/useCommonStore";
import { fakeAuthProvider } from "./auth";

let AuthContext = React.createContext(null);

function AuthProvider({ children }) {
  const user = useCommonStore.use.user();
    let value = { user };
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

function useAuth() {
    //修改通过zustand中获取登陆信息
    return React.useContext(AuthContext);
  }


export {AuthProvider, useAuth};